// extracted by mini-css-extract-plugin
export default {"title":"t3VR9","subtitle":"txzqQ","button":"g8R1e","errorScreenContainer":"gg6I2","fullScreenErrorContainer":"ENzpD","iconContainer":"OeBof"};